export default __webpack_public_path__ + "media/images/images/carousel/05-f94bbe29f3b0ddcb24f22a26239f97ce.jpg";